type LaserPointerOverlayProps = {
  x: number;
  y: number;
  visible: boolean;
  className?: string;
};

export default function LaserPointerOverlay({
  x,
  y,
  visible,
  className = "absolute pointer-events-none z-20",
}: LaserPointerOverlayProps) {
  if (!visible) return null;
  return (
    <div
      className={className}
      style={{
        left: `${x}%`,
        top: `${y}%`,
        transform: "translate(-50%, -50%)",
        transition: "left 50ms linear, top 50ms linear",
      }}
    >
      <div className="absolute inset-0 w-12 h-12 -translate-x-1/2 -translate-y-1/2 bg-red-500/30 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute inset-0 w-8 h-8 -translate-x-1/2 -translate-y-1/2 border-2 border-red-400/60 rounded-full animate-ping"></div>
      <div className="w-4 h-4 bg-red-500 rounded-full shadow-[0_0_20px_8px_rgba(239,68,68,0.6)]"></div>
    </div>
  );
}
